import { render, staticRenderFns } from "./_footers.vue?vue&type=template&id=cfa5aa1c"
import script from "./_footers.vue?vue&type=script&lang=js"
export * from "./_footers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports